import {WorkspaceTemplate} from '../../../graphql/workspaceTemplates';
import {DEFAULT_X_AXIS_OPTION} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotSettings} from '../../WorkspaceDrawer/Settings/types';
import {xAxisLabel} from '../../WorkspaceDrawer/Settings/utils';

export const getXAxisDisplayRow = (
  currTemplateLinePlotSettings: WorkspaceTemplate['linePlotSettings'],
  currWorkspaceLinePlotSettings?: LinePlotSettings
) => {
  const currTemplateXAxis = currTemplateLinePlotSettings?.xAxis;
  const newTemplateXAxis = currWorkspaceLinePlotSettings?.xAxis;

  return {
    label: 'X axis',
    value:
      currTemplateXAxis == null ? undefined : xAxisLabel(currTemplateXAxis),
    newValue:
      newTemplateXAxis == null
        ? DEFAULT_X_AXIS_OPTION.label
        : xAxisLabel(newTemplateXAxis),
  };
};
